<template>
    <el-dialog
        class="edit-currency"
        :visible.sync="editVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Edit Currency"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="editForm"
                :model="editForm"
                :rules="rules"
                label-width="70px"
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Name" prop="name" size="small">
                            <el-input
                                v-model="editForm.name"
                                placeholder="Please input name"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="Code" prop="code" size="small">
                            <el-input
                                v-model="editForm.code"
                                placeholder="Please input code"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="Symbol" prop="symbol" size="small">
                            <el-input
                                v-model="editForm.symbol"
                                placeholder="Please input symbol"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >Save</el-button
            >
            <el-button size="small" @click="editVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            editForm: {
                name: "",
                code: "",
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: "Please input name",
                    },
                ],
                code: [
                    {
                        required: true,
                        message: "Please input code",
                    },
                ],
                symbol: [
                    {
                        required: true,
                        message: "Please input symbol",
                    },
                ],
            },
        };
    },
    methods: {
        closeDialog() {
            this.editForm = {
                name: "",
                code: "",
            };
            this.$refs["editForm"].clearValidate();
            this.$refs["editForm"].resetFields();
            this.$emit("update:editVisible", false);
        },
        save() {
            this.$refs["editForm"].validate((valid) => {
                if (valid) {
                    cmofferApi
                        .currencyList(
                            {
                                ...this.editForm,
                            },
                            "post",
                            this.tableItem.id
                        )
                        .then((res) => {
                            if (res) {
                                this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "编辑成功"
                                        : "Success"
                                );
                                this.$parent[this.funcName] &&
                                    this.$parent[this.funcName]();
                                this.closeDialog();
                            }
                        });
                }
            });
        },
        currencyList() {
            cmofferApi
                .currencyList(
                    {
                    },
                    "get",
                    this.tableItem.id
                )
                .then((res) => {
                    if (res) {
                      this.editForm = { ...res.data };
                    }
                });
        },
    },
    props: {
        editVisible: Boolean,
        tableItem: Object,
        funcName: String,
    },
    watch: {
        editVisible(val) {
          this.currencyList();
        },
    },
};
</script>
<style lang="scss" scoped>
.edit-currency {
    .container {
    }
}
</style>
